// Render-time "now" helper.
//
// All dated rendering goes through `clockNow()` so the firm's ageing maths
// (SLAs, stale fact finds, "days since" labels) keeps moving after deploy
// rather than freezing on an anchored constant. Tests substitute the wall
// clock locally via fake timers — never a global mock — so individual
// snapshot/golden specs can pin their own moment without spilling state
// into unrelated suites.
export function clockNow(): Date {
    return new Date();
}

// Whole-day count from now until an ISO date (negative = in the past).
// Render-layer derivation used by the comply due-date pages; goes through
// clockNow() so the ageing maths keeps moving after deploy.
export function daysUntil(iso: string): number {
    return Math.round((new Date(iso).getTime() - clockNow().getTime()) / 86_400_000);
}
